'use strict';

const formValidation = require('../components/formValidation');
const {regexRFCPhysics, regexRFCMoral} = require('../util/invoiceProfile');

/**
 * Validates the RFC input in the invoice profile form.
 *
 * Checks if the RFC input matches either the physical or moral RFC format.
 * If valid, clears any validation errors; otherwise, sets a custom validation message.
 * Returns a boolean indicating if the RFC is valid.
 */
function handleRFCInputValidation() {
    const $txtRFC = $('.download-invoice-form .invoice-rfc');
    const invalidRfcMsg = $txtRFC.data('pattern-mismatch');
    const inputVal = $txtRFC.val().trim();
    const $Invalidfeedback = $txtRFC.next('.invalid-feedback');

    if (inputVal === '') {
        return;
    }

    const regexPhysics = new RegExp(regexRFCPhysics);
    const regexMoral = new RegExp(regexRFCMoral);

    const isValid = regexPhysics.test(inputVal) || regexMoral.test(inputVal);

    if (isValid) {
        $txtRFC.removeClass('is-invalid');
        $txtRFC[0].setCustomValidity('');
    } else {
        $txtRFC.addClass('is-invalid');
        $txtRFC[0].setCustomValidity(' ');
        $txtRFC[0].reportValidity();
        $Invalidfeedback .text(invalidRfcMsg);
    }

    return isValid;
}

function clearInvoiceForm() {
    $('input[name$="_invoiceSerial"]').val('');
    $('input[name$="_invoiceNumber"]').val('');
    $('input[name$="rfc"]').val('');
}

/**
 * Submits the download invoice form via AJAX and handles the response.
 *
 * @param {jQuery} $form - The jQuery object for the form.
 */
function handleDownloadInvoice($form) {
    var url = $form.attr('action');
    $form.parent().spinner().start();

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function(data) {
            $form.spinner().stop();
            if (!data.success) {
                formValidation($form, data);
                $(document).trigger('showNotificationClient', {
                    type: 'error',
                    message: data.errorMessage,
                    cssClass: ''
                });
            } else {
                if (data.downloadLink) {
                    var hiddenLink = $('#hiddeDownloadInvoiceLink');
                    hiddenLink.attr('href', data.downloadLink);
                    hiddenLink.attr('download', data.nameFileData);
                    hiddenLink[0].click();
                    $(document).trigger('showNotificationClient', {
                        type: 'success',
                        message: data.successMessage,
                        cssClass: ''
                    });
                    clearInvoiceForm();
                }
            }
        },
        error: function() {
            $form.parent().spinner().stop();
        }
    });
}


/**
 * Initialize download invoice form controls
 */
function initDownloadInvoiceSection() {
    $('.download-invoice-form').on('submit', function(event) {
        var $form = $(this);
        event.preventDefault();

        if (handleRFCInputValidation()) {
            handleDownloadInvoice($form);
        }
    });

    $('.download-invoice-form .invoice-rfc').on('input', function() {
        handleRFCInputValidation();
    });

}

module.exports = {
    initDownloadInvoiceSection: initDownloadInvoiceSection
};